import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import Table from '../../../common/Table';
import { BANK_RECONCILIATION_DEPOSIT_COLUMNS } from '../../../../config/columns';
import { BANK_RECONCILIATION_DEPOSIT_ROW_BACKGROUND } from '../../../../config/constants';
import {
  getBankReconciliationDeposits,
  clearBankReconciliationDeposits,
} from '../../../../actions';

const bankReconciliationDepositRowStyle = (row) => {
  if (!row || !row.original) return {};

  const background =
    BANK_RECONCILIATION_DEPOSIT_ROW_BACKGROUND[row.original.matchResult];

  return background ? { background } : {};
};

const BankReconciliationDepositsTable = ({
  liquidationId,
  deposits,
  loading,
  dispatchGetBankReconciliationDeposits,
  dispatchClearBankReconciliationDeposits,
}) => {
  useEffect(() => {
    dispatchGetBankReconciliationDeposits({ liquidationId });

    return () => dispatchClearBankReconciliationDeposits({ liquidationId });
  }, [liquidationId]);

  const data = deposits.toJS();

  return (
    <div className="p-3 pl-5 bg-white">
      <h6 className="text-muted">
        Depósitos de la liquidación {liquidationId}
      </h6>
      <Table
        columns={BANK_RECONCILIATION_DEPOSIT_COLUMNS(liquidationId)}
        data={data}
        loading={loading}
        manual={false}
        showPagination={false}
        pageSize={data.length || 1}
        groupedColumns
        generateStyle={bankReconciliationDepositRowStyle}
      />
      {/* <div className="mt-2 p-2 border rounded small text-muted bg-white">
        Cada fila es una cuenta del depósito, no el depósito: uno repartido entre
        dos bancos aparece dos veces, con su propio número de operación y su propio
        estado de migración, que pueden ser distintos entre sí. Un resultado{' '}
        <em>validado directo</em> significa que el banco no envía estado de cuenta
        y sus valores replican los de FLIT, no que se hayan verificado contra una
        segunda fuente.
      </div> */}
    </div>
  );
};

BankReconciliationDepositsTable.propTypes = {
  liquidationId: PropTypes.number.isRequired,
  deposits: PropTypes.instanceOf(Immutable.List).isRequired,
  loading: PropTypes.bool,
  dispatchGetBankReconciliationDeposits: PropTypes.func.isRequired,
  dispatchClearBankReconciliationDeposits: PropTypes.func.isRequired,
};

BankReconciliationDepositsTable.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ SalesUnit }, { liquidationId }) => ({
  deposits:
    SalesUnit.BankReconciliation.getIn([
      'depositsByLiquidation',
      liquidationId,
      'content',
    ]) || Immutable.List(),
  loading:
    SalesUnit.BankReconciliation.getIn([
      'depositsByLiquidation',
      liquidationId,
      'loading',
    ]) || false,
});

const mapDispatchToProps = {
  dispatchGetBankReconciliationDeposits: getBankReconciliationDeposits,
  dispatchClearBankReconciliationDeposits: clearBankReconciliationDeposits,
};

export { BankReconciliationDepositsTable };
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BankReconciliationDepositsTable);
